import { NgClass, NgTemplateOutlet } from '@angular/common';
import { Component, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges } from '@angular/core';

import { MaterialDisabledActionDirective } from '../../../directives/material-disabled-action.directive';
import { MaterialTargetDirective } from '../../../directives/material-target.directive';
import { MaterialItemListStatusClass } from './material-item-list.enum';

@Component({
    selector: 'ecm-mat-item-list',
    templateUrl: 'material-item-list.html',
    styleUrls: ['material-item-list.css'],
    standalone: true,
    imports: [MaterialTargetDirective, NgClass, MaterialDisabledActionDirective, NgTemplateOutlet],
})
export class MaterialItemListComponent implements OnInit, OnChanges {
    /**
     * Id may be provide to filter event emitter return in parent component
     * @type {string} id
     */
    @Input() public id?: string;

    /**
     * Path item
     * @type {string} itemPath
     */
    @Input() public itemPath?: string;

    /**
     * Status item
     * @type {string} itemStatus : critical | alert | danger | warning | info | success
     */
    @Input() public itemStatus?: 'critical' | 'alert' | 'danger' | 'warning' | 'info' | 'success';

    /**
     * Picto item
     * @type {string} itemIcon
     */
    @Input() public itemIcon?: string;

    /**
     * Label item
     * @type {string|array}  itemLabel
     */
    @Input() public itemLabel?: string;

    /**
     * Text item
     * @type {string|array}  itemText
     */
    @Input() public itemText?: string | string[];
    public displayedText: string[];

    /**
     * Alt label item
     * @type {string} itemAlt
     */
    @Input() public itemAlt?: string = "Information de l'image de votre item";

    /**
     * Is disabled state
     * @param {boolean} isDisabled
     */
    @Input() public isDisabled?: boolean = false;

    /**
     * Is disabled for eclair
     * @param {boolean} [isDisabledEclair=false]
     */
    @Input() public isDisabledEclair = false;

    /**
     * Is highlight state
     * @param {boolean} isHighlight
     */
    @Input() public isHighlight?: boolean = false;

    /**
     * Displays spinner
     */
    @Input() public isLoading?: boolean = false;

    /**
     * Displays border bottom
     */
    @Input() public hasNoBorder?: boolean = false;

    /**
     * Feedback data-e2e tag
     * 3 tags will be added to the DOM
     * {e2e}-{style} for the entire div
     * {e2e}-{style}-primary for the primary text
     * {e2e}-{style}-secondary for the secondary text
     * @type {string} e2e
     */
    @Input() public e2e?: string;

    /**
     * Event emitter
     */
    @Output() public materialItemListEvent: EventEmitter<any> = new EventEmitter<any>();

    public ngOnInit(): void {
        this.e2e = this.e2e ? this.e2e : 'e2e-material-list-item';
    }

    public ngOnChanges(changes: SimpleChanges): void {
        if (changes.itemText) {
            if (typeof this.itemText === 'string') {
                this.itemText = [this.itemText];
            }
            this.displayedText = this.itemText;
        }
    }

    /**
     * Get css class for status display
     * @param {string} status : "critical" | "alert" | "danger" | "warning" | "info" | "success";
     * @returns {string}
     */
    public getCssClassFromStatus(status: string): string {
        return typeof status === 'string' && MaterialItemListStatusClass[status]
            ? MaterialItemListStatusClass[status]
            : undefined;
    }

    /**
     * Emit event on item list action
     * we passe all object
     */
    public materialItemListConfirm(): void {
        this.materialItemListEvent.emit();
    }
}
